import { Component, ChangeDetectionStrategy } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {PartnerService} from '../../../../../services/partner/partner.service';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {Partner} from '../../../../../models/partner/partner';
import {Dialog} from '../../../../../interfaces/dialog/dialog';

@Component({
  selector: 'app-partner-duplicate',
  imports: [
    ReactiveFormsModule,
  ],
  templateUrl: './partner-duplicate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-duplicate.component.scss'
})
export class PartnerDuplicateComponent implements Dialog {

  partner!: Partner;
  submitting: boolean = false;

  form: FormGroup = new FormGroup({
    companyName: new FormControl('', [Validators.required]),
  });

  constructor(
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private partnerService: PartnerService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.partner = params.data.partner;

    this.form.patchValue({
      companyName: this.partner.companyName,
    });
  }

  invalid(): boolean {
    return this.form.invalid;
  }

  submit(): void {
    this.submitting = true;

    this.partnerService.create({
      accountManagerId: this.partner.accountManagerId,
      accountType: this.partner.accountType,
      status: this.partner.status,
      advertisingPlatform: this.partner.advertisingPlatform?.id ?? null,
      prospect: this.partner.prospect,
      companyStatus: this.partner.companyStatus,
      companyName: this.form.value.companyName,
      companyRegistrationNumber: this.partner.companyRegistrationNumber,
      companyVatNumber: this.partner.companyVatNumber,
      langs: this.partner.langs,
      country: this.partner.country,
      address: this.partner.address,
      zipCode: this.partner.zipCode,
      state: this.partner.state,
      city: this.partner.city,
      email: this.partner.email,
      phoneNumber: this.partner.phoneNumber,
      prospectOrigin: this.partner.prospectOrigin,
      typology: this.partner.typology,
      verticals: this.partner.verticals,
      geographicAreas: this.partner.geographicAreas,
      trafficSources: this.partner.trafficSources,
      experience: this.partner.experience,
      estimatedMonthlyRevenue: this.partner.estimatedMonthlyRevenue,
      websiteUrl: this.partner.websiteUrl,
      paymentThreshold: this.partner.paymentThreshold,
      paymentTerms: this.partner.paymentTerms,
      paymentCurrency: this.partner.paymentCurrency?.isoCode ?? null,
      paymentMethod: this.partner.paymentMethod,
      accountHolder: this.partner.accountHolder,
      bankName: this.partner.bankName,
      bankAddress: this.partner.bankAddress,
      iban: this.partner.iban,
      swift: this.partner.swift,
      routingNumber: this.partner.routingNumber,
      accountComplianceNote: this.partner.accountComplianceNote,
      credentialUrl: this.partner.credentialUrl,
      credentialUsername: this.partner.credentialUsername,
      credentialPassword: this.partner.credentialPassword,
      allOffersAccess: this.partner.allOffersAccess,
      subjectToVat: this.partner.subjectToVat,
      firstname: this.partner.getMainContact().firstname,
      lastname: this.partner.getMainContact().lastname,
      civility: this.partner.getMainContact().civility,
      telegram: this.partner.getMainContact().telegram,
      teams: this.partner.getMainContact().teams
    }).subscribe(() => {
      this.dialog.closeDialog();

      this.snackbar.success('Partner duplicated successfully. Do not forget to update its information, such as the partner name.');

      this.submitting = false;
    });
  }

}
